import {TranslateProvider} from "./context/TranslateContext";
import {LoaderProvider} from "./context/LoaderContext";
import {MobileProvider} from "./context/MobileContext";
import {AuthProvider} from "./context/AuthContext";
import {RuoliProvider} from "./context/RuoliContext";
import {RichiedentiProvider} from "./context/RichiedentiContext";
import {CertificatiProvider} from "./context/CertificatiContext";
import {FiltersProvider} from "./context/FiltersContext";
import {BreadcrumbsProvider} from "./context/BreadcrumbsContext";

function ProvidersComponent({children}) {
    return (
        <TranslateProvider value={"it"}>
            <LoaderProvider>
                <MobileProvider>
                    <AuthProvider>
                        <BreadcrumbsProvider>
                            <RuoliProvider>
                                <RichiedentiProvider>
                                    <CertificatiProvider>
                                        <FiltersProvider>
                                            {children}
                                        </FiltersProvider>
                                    </CertificatiProvider>
                                </RichiedentiProvider>
                            </RuoliProvider>
                        </BreadcrumbsProvider>
                    </AuthProvider>
                </MobileProvider>
            </LoaderProvider>
        </TranslateProvider>
    )
}

export default ProvidersComponent;